import { TYPES } from "./voucher.type";

const initState = {
  all: null,
  vouchers: null,
  detail: null,
  redeem: null,
  voucherByDate: null,
  voucherRedeemByDate: null,
};

const voucherReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_ALL_VOUCHER_PACKAGE_SUCCESS:
      return {
        ...state,
        all: payload,
      };

    case TYPES.GET_VOUCHER_SUCCESS:
      return {
        ...state,
        vouchers: payload,
      };

    case TYPES.GET_PACKAGE_DETAIL_SUCCESS:
      return {
        ...state,
        detail: payload,
      };

    case TYPES.SELECT_REDEEM_SUCCESS:
      return {
        ...state,
        redeem: payload,
      };

    //cashup
    case TYPES.GET_VOUCHER_BYDATE_SUCCESS:
      return {
        ...state,
        voucherByDate: payload,
      };
    case TYPES.GET_VOUCHER_REDEEM_BYDATE_SUCCESS:
      return {
        ...state,
        voucherRedeemByDate: payload,
      };

    default:
      return state;
  }
};

export default voucherReducer;
